module.exports = __webpack_public_path__ + "static/media/civilians-icon.448027fa.svg";